<app-document [document]="publication" [canDelete]="false">
  <ng-container actions-before>
    @if (publication.signed) {
      <i class="fa-regular fa-signature text-gray-800" [title]="'signature.status.signed' | translate"></i>
    }
  </ng-container>
</app-document>
